import { motion } from "framer-motion";
import { fade } from "../_shared/motion";
import { STEPS } from "./constants";

export default function StepsSection() {
    return (
        <section className="py-16 md:py-20 bg-[#F7F5F0]" data-testid="referral-steps">
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
                <div className="max-w-2xl mb-12">
                    <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium">
                        Our 4-step process
                    </p>
                    <h2 className="mt-3 font-[Outfit] text-3xl md:text-4xl font-semibold tracking-tight">
                        How admissions work.
                    </h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                    {STEPS.map((s, i) => (
                        <motion.div
                            key={s.n}
                            {...fade}
                            transition={{ ...fade.transition, delay: i * 0.05 }}
                            className="bento-card bg-white rounded-2xl p-6 border border-[#E5DFD3] flex flex-col h-full"
                            data-testid={`step-${i + 1}`}
                        >
                            <div className="flex items-center justify-between mb-4">
                                <div className="h-11 w-11 rounded-xl bg-[#E8EFE8] grid place-items-center text-[#0E2A47]">
                                    <s.icon className="h-5 w-5" />
                                </div>
                                <span className="font-[Outfit] text-[28px] font-semibold text-[#C8A24A] leading-none">
                                    {s.n}
                                </span>
                            </div>
                            <h3 className="font-[Outfit] text-[17px] font-semibold tracking-tight mb-2">
                                {s.title}
                            </h3>
                            <p className="text-[13.5px] leading-relaxed text-[#6F6B63]">
                                {s.body}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
